<template>
    <div>
        <rkm-form
            ref="RkmForm"
            v-if="form"
        >
            <rkm-area
                no-margin-top
                title="CBO's AUTORIZADOS A ATUALIZAR O ENDEREÇO DO CADASTRO DO PACIENTE"
                type="fieldset"
            >

                <rkm-row>
                    <rkm-col>
                        <rkm-form-input-autocomplete
                            :repository="repositories.ocupacao"
                            :search-fields="searchFields"
                            :text-field="(item) => item.codigo ? `${item.codigo} - ${item.nome}` : null"
                            :validations="validations.ocupacao"
                            label="CBO"
                            v-model="model.ocupacao"
                        />
                    </rkm-col>

                    <rkm-col cols="auto">
                        <rkm-button
                            :label="false"
                            @click="addOcupacoes"
                            color="primary"
                        >
                            Incluir
                        </rkm-button>

                        <rkm-button
                            :label="false"
                            @click="clean"
                        >
                            Limpar
                        </rkm-button>
                    </rkm-col>
                </rkm-row>

                <rkm-area
                    no-margin-top
                    title="Listagem de cbo's cadastrados"
                >
                    <rkm-table
                        :fields="fields"
                        :items="model.ocupacoes"
                    >
                        <template v-slot:cell(ocupacao)="{item}">
                            {{item.codigo}} - {{item.nome}}
                        </template>

                        <template v-slot:cell(actions)="row">

                            <rkm-button
                                @click="destroy(row.item)"
                                color="danger"
                                small
                                title="Excluir"
                            >
                                <rkm-icon icon="trash" />
                            </rkm-button>
                        </template>
                    </rkm-table>
                </rkm-area>
            </rkm-area>
        </rkm-form>

        <rkm-form
            ref="RkmFormUsuario"
            v-if="form"
        >
            <rkm-area
                no-margin-top
                title="Permissão - Usuários que podem realizar cadastro de paciente"
                type="fieldset"
            >

                <rkm-row>
                    <rkm-col cols="4">
                        <rkm-form-select
                            :options="form.unidades"
                            label="Unidade"
                            text-field="nomeFantasia"
                            show-default-option
                            v-model="model.unidadeId"
                            :validations="validations.unidade"
                            value-field="id"
                            @change="getInfraestruturas"
                            :disabled="isChange"
                        />
                    </rkm-col>

                    <rkm-col cols="4">
                        <rkm-form-select
                            :options="form.infraestruturas"
                            label="Local de atendimento"
                            text-field="nome"
                            show-default-option
                            v-model="model.infraestruturaId"
                            :validations="validations.infraestrutura"
                            value-field="id"
                            @change="getUsuarios"
                            :disabled="isChange"
                        />
                    </rkm-col>

                    <rkm-col cols="4">
                        <rkm-form-select
                            :options="form.usuarios"
                            label="Usuário"
                            text-field="nome"
                            show-default-option
                            v-model="model.usuarioId"
                            :validations="validations.usuario"
                            value-field="id"
                            :disabled="isChange"
                        />
                    </rkm-col>
                </rkm-row>

                <rkm-row>
                    <rkm-col cols="2">
                        <rkm-form-checkbox v-model="model.municipe">
                            Munícipe
                        </rkm-form-checkbox>
                    </rkm-col>

                    <rkm-col cols="2">
                        <rkm-form-checkbox v-model="model.provisorio">
                            Provisório
                        </rkm-form-checkbox>
                    </rkm-col>

                    <rkm-col cols="2">
                        <rkm-form-checkbox v-model="model.outroMunicipio">
                            Outro município
                        </rkm-form-checkbox>
                    </rkm-col>

                    <rkm-col cols="3">
                        <rkm-form-checkbox v-model="model.desbloquearUsuario">
                            Desbloquear paciente
                        </rkm-form-checkbox>
                    </rkm-col>
                </rkm-row>

                <rkm-row class="mt-2">
                    <rkm-col cols="12">
                        <rkm-form-checkbox-group
                            :options="form.pacienteAbas"
                            label="Abas"
                            text-field="nome"
                            v-model="model.pacienteAbas"
                            value-field="id"
                        />
                    </rkm-col>
                </rkm-row>

                <rkm-row>
                    <rkm-col cols="auto">
                        <rkm-button
                            @click="addUsuarios"
                            color="primary"
                        >
                            {{ isChange ? 'Alterar' : 'Incluir' }}
                        </rkm-button>

                        <rkm-button
                            @click="resetFormUsuario"
                        >
                            Limpar
                        </rkm-button>
                    </rkm-col>
                </rkm-row>

                <rkm-area
                    v-if="!isChange"
                    no-margin-top
                    title="Listagem de permissões cadastradas"
                >

                    <rkm-table
                        :fields="fieldsUsuarios"
                        :items="model.usuarios"
                        sort-by="unidadeNomeFantasia"
                    >

                        <template v-slot:cell(municipe)="{item}">
                            {{ item.municipe ? 'SIM' : 'NÃO' }}
                        </template>

                        <template v-slot:cell(provisorio)="{item}">
                            {{ item.provisorio ? 'SIM' : 'NÃO' }}
                        </template>

                        <template v-slot:cell(outroMunicipio)="{item}">
                            {{ item.outroMunicipio ? 'SIM' : 'NÃO' }}
                        </template>

                        <template v-slot:cell(desbloquearUsuario)="{item}">
                            {{ item.desbloquearUsuario ? 'SIM' : 'NÃO' }}
                        </template>

                        <template v-slot:cell(pacienteAbas)="{item}">
                            <div
                                v-for="aba in item.pacienteAbas"
                                :key="aba.id"
                            >
                                - {{ aba.nome }}
                            </div>
                        </template>

                        <template v-slot:cell(actions)="row">

                            <rkm-button
                                @click.stop="handleEdit(row.item)"
                                color="primary"
                                small
                                title="Editar"
                            >
                                <rkm-icon icon="pen" />
                            </rkm-button>

                            <rkm-button
                                @click="destroyPermissao(row.item)"
                                color="danger"
                                small
                                title="Excluir"
                            >
                                <rkm-icon icon="trash" />
                            </rkm-button>
                        </template>
                    </rkm-table>
                </rkm-area>
            </rkm-area>
        </rkm-form>

        <rkm-form
            ref="RkmFormOutros"
            v-if="form"
        >
            <rkm-area
                no-margin-top
                title="Configurações de Avisos/Alertas"
                type="fieldset"
            >
                <rkm-row>
                    <rkm-col cols="2">

                        <rkm-form-input
                            name="Usuário"
                            v-model="model.cadastroPacienteDesatualizadoQuantidadeDias"
                        >
                            <rkm-input-group-append slot="append">
                                <rkm-input-group-text>
                                    dia(s)
                                </rkm-input-group-text>
                            </rkm-input-group-append>
                        </rkm-form-input>
                    </rkm-col>
                    <rkm-col cols="10" class="pt-1"> Quantidade de dias após a última atualização em que o cadastro
                        será classificado como desatualizado.</rkm-col>
                </rkm-row>

                <rkm-row>
                    <rkm-col cols="12">
                        <rkm-form-checkbox v-model="model.exibeAlertaPacienteCnsTemporarioInvalido">
                            Exibir alerta de que o CNS do paciente é temporário/inválido.
                        </rkm-form-checkbox>
                    </rkm-col>
                </rkm-row>

                <rkm-row>
                    <rkm-col cols="12">
                        <rkm-form-checkbox
                            v-model="model.cadastroPacienteEnderecoDesatualizadoBloqueado"
                            tooltip-text="Quando ativa o bloqueio do cadastro do paciente será realizado independente do prazo de vencimento, informando sobre a necessidade de atualizar o endereço."
                        >
                            Bloquear cadastro se endereço estiver desatualizado
                        </rkm-form-checkbox>
                    </rkm-col>
                </rkm-row>
            </rkm-area>

            <rkm-area
                no-margin-top
                title="Bloqueio de Pacientes Temporários"
                type="fieldset"
            >

                <rkm-row>
                    <rkm-col cols="12">
                        <rkm-form-checkbox v-model="model.cadastroPacienteProvisorioBloqueado">
                            Se ativa bloqueia os cadastros de pacientes com cadastros temporários de acordo
                            com a validade dos cadastros.
                        </rkm-form-checkbox>
                    </rkm-col>
                </rkm-row>
            </rkm-area>

            <rkm-area
                no-margin-top
                title="Validade de Pacientes Temporários"
                type="fieldset"
            >

                <rkm-row>
                    <rkm-col cols="2">

                        <rkm-form-input
                            name="Usuário"
                            v-model="model.cadastroPacienteProvisorioQuantidadeDias"
                        >
                            <rkm-input-group-append slot="append">
                                <rkm-input-group-text>
                                    dia(s)
                                </rkm-input-group-text>
                            </rkm-input-group-append>
                        </rkm-form-input>
                    </rkm-col>
                    <rkm-col cols="10" class="pt-1"> Informe a quantidade de dias em que o cadastro temporário permanece
                        ativo após sua data de validade.
                    </rkm-col>
                </rkm-row>
            </rkm-area>
        </rkm-form>

        <rkm-form v-if="model">
            <rkm-area
                title="Material"
                type="fieldset"
            >
                <rkm-row>
                    <rkm-col cols="4">
                        <rkm-form-checkbox v-model="model.material.geraCodigoAutomatico">
                            Gerar código automaticamente
                        </rkm-form-checkbox>
                    </rkm-col>
                </rkm-row>
            </rkm-area>
        </rkm-form>

        <rkm-area
            v-if="model"
            title="Configuração de validações"
            type="fieldset"
        >
            <rkm-row>
                <rkm-col cols="auto">
                    <rkm-form-checkbox
                        @change="handleExigeCpfPacienteChange"
                        v-model="model.validacoes.exigeCpfPaciente"
                    >
                        Exigir o preenchimento do CPF no cadastro do paciente
                    </rkm-form-checkbox>
                </rkm-col>

                <rkm-col cols="auto">
                    <rkm-form-checkbox
                        @change="handleExigeCnsPacienteChange"
                        v-model="model.validacoes.exigeCnsPaciente"
                    >
                        Exigir o preenchimento do CNS no cadastro do paciente
                    </rkm-form-checkbox>
                </rkm-col>
            </rkm-row>
        </rkm-area>

        <rkm-area
            v-if="model && cliente && cliente.ativoAppConectasusCidadao"
            title="Integrações de Aplicativos"
            type="fieldset"
        >
            <rkm-row>
                <rkm-col cols="auto">
                    <rkm-form-checkbox v-model="model.integracaoAplicativo.habilitaMinhaFamiliaConectasusCidadao">
                        Habilitar a funcionalidade Minha Família no APP Cidadão
                    </rkm-form-checkbox>
                </rkm-col>

                <rkm-col cols="auto">
                    <rkm-form-checkbox v-model="model.integracaoAplicativo.habilitaDependenteMaiorIdadeConectasusCidadao">
                        Permitir a visualização de dependentes maiores de idade na funcionalidade Minha Família
                    </rkm-form-checkbox>
                </rkm-col>
            </rkm-row>
        </rkm-area>
    </div>
</template>

<script>
// Mixins.
import { repository, error, stringCase, object } from '@/mixins'

// Vuex.
import {mapActions, mapGetters} from 'vuex'

export default {
    computed: {
        ...mapGetters({cliente: 'getCliente'}),

        searchFields() {
            return [
                {key: 'ocupacao.codigo', searchable: true},
                {key: 'ocupacao.nome', searchable: true},
            ]
        },
        validations() {
            return {
                ocupacao: {required: true},
                unidade: {required: true},
                infraestrutura: {required: true},
                usuario: {required: true},
            }
        },
    },
    created() {
        this.repositories = {
            ocupacao: this.getConectaSusRepository('sigtap.ocupacao'),
            parametrizacao: this.getConectaSusRepository('cadastro.parametrizacao'),
        }
    },
    data: () => ({
        fields: [
            {key: 'ocupacao', label: 'CBO', sortable: true},
            {class: 'col-min text-center', key: 'actions', label: 'Ações'},
        ],
        fieldsUsuarios: [
            {key: 'unidadeNomeFantasia', label: 'Unidade', sortable: true},
            {key: 'infraestruturaNome', label: 'Local de atendimento', sortable: true},
            {key: 'usuarioNome', label: 'Usuário', sortable: true},
            {class: 'col-min text-center', key: 'municipe', label: 'Munícipe', sortable: true},
            {class: 'col-min text-center', key: 'provisorio', label: 'Provisório', sortable: true},
            {class: 'col-min text-center', key: 'outroMunicipio', label: 'Outro município', sortable: true},
            {class: 'col-min text-center', key: 'desbloquearUsuario', label: 'Desbloquear', sortable: true},
            {class: 'col-min', key: 'pacienteAbas', label: 'Aba(s)'},
            {class: 'col-min text-center', key: 'actions', label: 'Ações'},
        ],
        item: null,
        form: null,
        model: null,
        isChange: false,
    }),
    methods: {
        ...mapActions(['setLoading', 'unsetLoading']),
        load() {
            this.setLoading()

            this.repositories.parametrizacao.create()
                .then(response => {
                    this.form = Object.assign(response.data.form)
                    this.model = Object.assign(response.data.model)
                })
                .catch(this.handleError)
                .finally(() => this.unsetLoading())
        },
        save() {

            this.setLoading()

            this.repositories.parametrizacao.store(this.prepareData())
                .then(({ data }) => {

                    this.showSaveNotification()
                    this.$emit('save', data)
                })
                .catch(this.handleError)
                .finally(() => this.unsetLoading())
        },
        prepareData() {

            const usuarios = this.model.usuarios.map(permissao => ({
                infraestruturaId: permissao.infraestruturaId,
                usuarioId: permissao.usuarioId,
                municipe: permissao.municipe,
                provisorio: permissao.provisorio,
                outroMunicipio: permissao.outroMunicipio,
                desbloquearUsuario: permissao.desbloquearUsuario,
                pacienteAbas: permissao.pacienteAbas.map(a => a.id)
            }))

            const ocupacoes = this.model.ocupacoes.map(ocupacao => ({
                id: ocupacao.id,
            }))

            const cadastroPacienteDesatualizadoQuantidadeDias = this.model.cadastroPacienteDesatualizadoQuantidadeDias
            const exibeAlertaPacienteCnsTemporarioInvalido = this.model.exibeAlertaPacienteCnsTemporarioInvalido
            const cadastroPacienteProvisorioBloqueado = this.model.cadastroPacienteProvisorioBloqueado
            const cadastroPacienteProvisorioQuantidadeDias = this.model.cadastroPacienteProvisorioQuantidadeDias
            const cadastroPacienteEnderecoDesatualizadoBloqueado = this.model.cadastroPacienteEnderecoDesatualizadoBloqueado

            const validacoes = {
                exigeCpfPaciente: this.model.validacoes.exigeCpfPaciente,
                exigeCnsPaciente: this.model.validacoes.exigeCnsPaciente,
            }

            return this.camelObjectKeysToSnakeRecursive({
                usuarios, ocupacoes, cadastroPacienteDesatualizadoQuantidadeDias, exibeAlertaPacienteCnsTemporarioInvalido,
                cadastroPacienteProvisorioBloqueado, cadastroPacienteProvisorioQuantidadeDias,
                cadastroPacienteEnderecoDesatualizadoBloqueado, validacoes,
                material: this.model.material,
                integracaoAplicativo: this.model.integracaoAplicativo,
            })
        },
        addOcupacoes() {
            this.$refs.RkmForm.validate()
                .then(valid => {
                    if (valid === false) return

                    if (this.model.ocupacoes && this.model.ocupacoes.find(ocupacao => ocupacao.id === this.model.ocupacao.id)) {
                        this.showValidationNotification('O CBO já foi incluído.')
                        return
                    }

                    this.model.ocupacoes.push({
                        id: this.model.ocupacao.id,
                        codigo: this.model.ocupacao.codigo,
                        nome: this.model.ocupacao.nome,
                    })

                    this.resetForm()
                })
        },
        addUsuarios() {
            this.$refs.RkmFormUsuario.validate()
                .then(valid => {
                    if (valid === false) return

                    if (!this.isChange && this.model.usuarios
                        && this.model.usuarios.find(ocupacao => ocupacao.infraestruturaId === this.model.infraestruturaId
                        && ocupacao.usuarioId === this.model.usuarioId)
                    ) {

                        this.showValidationNotification('O usuário já foi incluído.')
                        return
                    }

                    const unidade = this.form.unidades.find(unidade => unidade.id === this.model.unidadeId)
                    const infraestrutura = this.form.infraestruturas.find(infraestrutura => infraestrutura.id === this.model.infraestruturaId)
                    const usuario = this.form.usuarios.find(usuario => usuario.id === this.model.usuarioId)

                    const param = {
                        unidadeId: this.model.unidadeId,
                        unidadeNomeFantasia: unidade.nomeFantasia,
                        infraestruturaId: this.model.infraestruturaId,
                        infraestruturaNome: infraestrutura.nome,
                        usuarioNome: usuario.nome,
                        usuarioId: this.model.usuarioId,
                        municipe: this.model.municipe,
                        provisorio: this.model.provisorio,
                        outroMunicipio: this.model.outroMunicipio,
                        desbloquearUsuario: this.model.desbloquearUsuario,
                        pacienteAbas: this.model.pacienteAbas.map(id => this.clone(this.form.pacienteAbas.find(a => a.id === id)))
                    }

                    const index = this.model.usuarios.findIndex(usuario => usuario.infraestruturaId === this.model.infraestruturaId
                        && usuario.usuarioId === this.model.usuarioId
                    )

                    if (index !== -1) {

                        this.$set(this.model.usuarios, index, this.clone(param))
                    } else {

                        this.model.usuarios.push(this.clone(param))
                    }

                    this.resetFormUsuario()
                })
        },
        destroy(item) {

            const index = this.model.ocupacoes.findIndex(permissao => permissao.id === item.id)

            this.showDeleteConfirmation('Deseja realmente excluir o CBO?', async () => {
                this.model.ocupacoes.splice(index, 1)
            })
        },
        destroyPermissao(item) {

            const index = this.model.usuarios.findIndex(permissao => permissao.infraestruturaId === item.infraestruturaId
                && permissao.usuarioId === item.usuarioId
            )

            this.showDeleteConfirmation('Deseja realmente excluir a permissão?', async () => {
                this.model.usuarios.splice(index, 1)
            })
        },
        clean() {
            this.resetForm()
        },
        resetForm() {
            this.model.ocupacao = null

            this.$nextTick().then(() => this.$refs.RkmForm.resetValidator())
        },
        resetFormUsuario() {

            this.model.unidadeId = null
            this.model.infraestruturaId = null
            this.model.usuarioId = null
            this.model.municipe = null
            this.model.provisorio = null
            this.model.outroMunicipio = null
            this.model.desbloquearUsuario = null
            this.model.pacienteAbas = []
            this.isChange = false

            this.$nextTick().then(() => this.$refs.RkmFormUsuario.resetValidator())
        },
        handleEdit(item) {

            this.model.unidadeId = item.unidadeId
            this.model.infraestruturaId = item.infraestruturaId
            this.model.usuarioId = item.usuarioId
            this.model.municipe = item.municipe
            this.model.provisorio = item.provisorio
            this.model.outroMunicipio = item.outroMunicipio
            this.model.desbloquearUsuario = item.desbloquearUsuario
            this.model.pacienteAbas = item.pacienteAbas.map(a => a.id)
            this.isChange = true

            this.getInfraestruturas()
            this.getUsuarios()
        },
        getInfraestruturas() {

            const request = {
                unidadeId: this.model.unidadeId,
            }

            this.setLoading()

            this.repositories.parametrizacao.getInfraestruturas(this.camelObjectKeysToSnakeRecursive(request))
                .then(response => {
                    this.form.infraestruturas = Object.assign(response.data)
                })
                .catch(this.handleError)
                .finally(() => this.unsetLoading())
        },
        getUsuarios() {

            const request = {
                infraestruturaId: this.model.infraestruturaId,
            }

            this.setLoading()

            this.repositories.parametrizacao.getUsuarios(this.camelObjectKeysToSnakeRecursive(request))
                .then(response => {
                    this.form.usuarios = Object.assign(response.data)
                })
                .catch(this.handleError)
                .finally(() => this.unsetLoading())
        },
        handleExigeCpfPacienteChange(exige) {
            if (!exige && !this.model.validacoes.exigeCnsPaciente) {
                this.showWarningNotification(`Não é permitido desativar simultaneamente a obrigatoriedade de CPF e CNS.
                    Mantenha ao menos uma identificação obrigatória ativa`)

                this.model.validacoes.exigeCpfPaciente = true
            }
        },
        handleExigeCnsPacienteChange(exige) {
            if (!exige && !this.model.validacoes.exigeCpfPaciente) {
                this.showWarningNotification(`Não é permitido desativar simultaneamente a obrigatoriedade de CPF e CNS.
                    Mantenha ao menos uma identificação obrigatória ativa`)

                this.model.validacoes.exigeCnsPaciente = true
            }
        },
    },
    mixins: [ repository, error, stringCase, object ],
    mounted() {
        this.load()
    }
}
</script>
